<template>

    <div class="order-infoTab-section1">
        <div class="order-pay-record">

                <el-form :inline="true":model="searchModel" ref="searchModel" >
                    <el-form-item label="业务员：">
                        <el-input v-model="searchModel.name" placeholder="请输入关键词"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" size="small" @click="getLog"> 搜索
                        </el-button>
                        <el-button type="default" size="small" @click="resetSearch"> 重置</el-button>
                        <el-button size="small" type="success" v-if="Acs('/customer/accounts/export')"
                                   @click="exportLog">记录导出
                        </el-button>
                    </el-form-item>
                </el-form>


            <el-table :data="logs" border style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column prop="username" label="业务员"></el-table-column>
                <el-table-column prop="bind_time_text" label="绑定时间"></el-table-column>
                <el-table-column prop="unbind_time_text" label="解绑时间"></el-table-column>
                <el-table-column prop="had_bind_time" label="绑定时长"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import CustomerService from "~/services/customer.js";
    import Pagination from "~/widgets/Pagination.vue";
    import Rule from "~/services/Rule";
    import OrderAuditLog from "~/services/OrderAuditLog";
    import customer from "~/services/customer";

    export default {
        name: "CustomerBindLogs",
        components: {
            Pagination
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        data() {
            return {
                logs: [],
                linkPage: null,
                loading: true,
                // 搜索列表模型
                searchModel: {
                    'name':'',
                    'customer_id':'',
                },
            }
        },
        created() {
            this.searchModel.customer_id = this.customerId;
            if (this.logs.length == 0) {
                this.getBindLog({customer_id: this.customerId})
            }
        },
        methods: {
            getBindLog(params) {
                CustomerService.getBindLog(params).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                })
            },
            exportLog() {
                OrderAuditLog.customerBindtLog(this.searchModel);
            },

            getLog() {
                CustomerService.getBindLog(this.searchModel).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                })
            },
            resetSearch() {
                this.searchModel = {
                    name: '',
                    customer_id:this.customerId
                };
                this.getBindLog(this.searchModel);
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getBindLog({
                    page: pageParams["page"],
                    perPage: pageParams["perPage"],
                    name:this.searchModel.name,
                    customer_id: this.customerId,
                });
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/BindLogs.vue